var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"authLoader"},[_c('div',{staticClass:"loaderContent"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("../../../../assets/images/pos-logo.png"),"max-width":"100"}})]),_c('div',{staticClass:"loaderWrapper"},[_c('div',{staticClass:"loader"})])])])
}]

export { render, staticRenderFns }